import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import makeStyles from '@material-ui/styles/makeStyles';
import { _T } from 'appI18n';
const useStyles = makeStyles({
    root: {
        width: "100%",
        overflowX: "auto",
    },
    hotelscol: {},
    availcol: {},
    accmdcol: {},
    pricecol: {},
    mealcol: {},
    actionscol: {},
}, { name: "AccomodationVariantList" });
export default function AccomodationVariantList(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const classes = useStyles();
    const firstColumn = React.createElement(TableCell, { className: `${classes.hotelscol} ${(_a = props.classes) === null || _a === void 0 ? void 0 : _a.hotelscol}` }, (_b = props.firstColumnTitle) !== null && _b !== void 0 ? _b : _T.COMMON_HOTEL);
    const availabilityColumn = React.createElement(TableCell, { className: `${classes.availcol} ${(_c = props.classes) === null || _c === void 0 ? void 0 : _c.availcol}` }, _T.COMMON_AVAILABILITY);
    const accommodationColumn = React.createElement(TableCell, { className: `${classes.accmdcol} ${(_d = props.classes) === null || _d === void 0 ? void 0 : _d.accmdcol}` }, _T.COMMON_ACCOMMODATION);
    const mealColumn = React.createElement(TableCell, { className: `${classes.mealcol} ${(_e = props.classes) === null || _e === void 0 ? void 0 : _e.mealcol}` }, _T.COMMON_MEAL);
    const priceColumn = React.createElement(TableCell, { className: `${classes.pricecol} ${(_f = props.classes) === null || _f === void 0 ? void 0 : _f.pricecol}` }, _T.COMMON_PRICE);
    const actionsColumn = React.createElement(TableCell, { className: `${classes.actionscol} ${(_g = props.classes) === null || _g === void 0 ? void 0 : _g.actionscol}` });
    return (React.createElement(TableContainer, { className: classes.root },
        React.createElement(Table, { style: props.minWidth ? { minWidth: props.minWidth } : undefined },
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    firstColumn,
                    props.availabilityBeforePrice ? accommodationColumn : availabilityColumn,
                    props.availabilityBeforePrice ? mealColumn : accommodationColumn,
                    props.availabilityBeforePrice ? availabilityColumn : mealColumn,
                    priceColumn,
                    actionsColumn)),
            React.createElement(TableBody, null, props.children))));
}
